import { render, staticRenderFns } from "./ProcessingPriceList.vue?vue&type=template&id=4ab95b68"
import script from "./ProcessingPriceList.vue?vue&type=script&lang=js"
export * from "./ProcessingPriceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports